import LegalLayout from "@/components/legal/LegalLayout";

export default function PhotoRelease() {
  return (
    <LegalLayout title="Photo & Video Release" effectiveDate="February 13, 2026">
      <p>
        By attending a Business Showers event and/or by uploading media to our designated photo-sharing platform (currently
        <strong> Kululu</strong>), you understand and agree to the following release.
      </p>

      <h2>1. What We Capture</h2>
      <ul>
        <li>Group and candid photos of the venue, honorees, sponsors, panelists, volunteers, and attendees.</li>
        <li>Ceremony, panel, and stage video (which may be livestreamed).</li>
        <li>Photos and video that <em>you</em> upload to our designated event photo platform.</li>
      </ul>

      <h2>2. What We Do With It</h2>
      <p>
        You grant <strong>Freedom In Me</strong> a worldwide, royalty-free, non-exclusive license to use, reproduce, edit, publish, and
        display the photos and video that include your likeness or that you upload, for:
      </p>
      <ul>
        <li>Event recap posts, social media, and website updates.</li>
        <li>Marketing and promotion of future Business Showers events, honoree programs, sponsorships, and volunteer recruitment.</li>
        <li>Grant reporting, press coverage, and community storytelling.</li>
        <li>Internal archives.</li>
      </ul>
      <p>
        This license continues even after the event ends. We may crop, color-correct, and add text or brand elements consistent with editorial and
        marketing use, but we will not fundamentally alter the meaning of the image.
      </p>

      <h2>3. What We Will Not Do</h2>
      <ul>
        <li>Sell your image to a third-party advertiser or stock library.</li>
        <li>Use your image in a way that could reasonably be considered defamatory or embarrassing.</li>
        <li>Use images of minors without additional parental consent.</li>
      </ul>

      <h2>4. Your Ownership</h2>
      <p>
        Photos and videos you upload remain <strong>your property</strong>. You are simply granting Freedom In Me a license to use them for the purposes above.
        You are free to use, share, or delete your own copies independently at any time.
      </p>

      <h2>5. If You Do Not Want to Appear in Event Photos</h2>
      <ol>
        <li>
          At check-in, tell a volunteer or event manager. We will note it in your attendee record and photographers will do their best to avoid you in
          identifiable frames.
        </li>
        <li>
          If you notice a specific photo online that includes you and you would like it removed, email us at
          <a href="mailto:info@itsthefreedominme.com"> info@itsthefreedominme.com</a> with a link or thumbnail. We will remove it from our channels
          within a reasonable time.
        </li>
      </ol>
      <p>
        Please note: livestream footage cannot be edited retroactively for individual removals, but we will remove clips containing you from our archives on request.
      </p>

      <h2>6. Uploading Photos to Our Photo Platform</h2>
      <p>
        When you upload photos or videos to our designated event photo platform (currently Kululu) through the QR code or link we provide, you additionally agree:
      </p>
      <ul>
        <li>You own the media or have permission from the photographer/videographer.</li>
        <li>You have permission from any recognizable person in the media to share the media publicly through our shared album and live wall.</li>
        <li>You will not upload media that is unlawful, harassing, or violates anyone else's rights.</li>
      </ul>
      <p>
        We reserve the right to remove any uploaded media that we believe violates these terms or the community spirit of the event.
      </p>

      <h2>7. Minors</h2>
      <p>
        We take extra care with photos of children. Children under 18 will not appear in individually identifiable marketing images without a parent or
        guardian's explicit written consent. If your child appears in a group photo and you would like it removed, contact us and we will remove it.
      </p>

      <h2>8. Contact</h2>
      <p>
        <strong>Freedom In Me</strong> — Photo Requests<br />
        <a href="mailto:info@itsthefreedominme.com">info@itsthefreedominme.com</a>
      </p>
      <p>
        We aim to respond to photo-related requests within 5 business days.
      </p>
    </LegalLayout>
  );
}
